// extracted by mini-css-extract-plugin
export default {"mainContainer":"CancellationandRefundPolicy_mainContainer__7FgtU"};